export const quickFilterParser = (quickFilter: string) => [quickFilter];
